// eslint-disable-next-line @typescript-eslint/no-unused-vars
const sendEventTrack = (_eventName: string, _value?: any) => {};

export { sendEventTrack };
